import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LanguageTransitionWrapper from "@/components/LanguageTransitionWrapper";
import StructuredData from "@/components/StructuredData";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import VideoUpload from "./pages/VideoUpload";
import Auth from "./pages/Auth";
import CorporateCalculator from "./pages/CorporateCalculator";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <StructuredData />
        <LanguageTransitionWrapper>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/video-upload" element={<VideoUpload />} />
            <Route path="/corporate-calculator" element={<CorporateCalculator />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LanguageTransitionWrapper>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
